// backend urls that we shouldn't prepend `/v1` before
export const excludedVersionPaths = [
  /(?=^default)(^((?!me).)*$)/,
  /recaptcha/
]
